import { FunctionComponent } from 'react';

export interface DisplayToggleBoxProps {
    hidden: boolean;
}

/* To prevent tree re-rendering. */

const DisplayToggleBox: FunctionComponent<DisplayToggleBoxProps> = ({ children, hidden }) => {
    return <div style={{ display: hidden ? 'none' : 'block' }}>{children}</div>;
};

export default DisplayToggleBox;
